import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Tag } from 'core/components';
import { isPastDate } from 'core/util/dateUtils';
const LABELS = {
  updated: {
    label: 'Updated',
    className: 'updated',
    intent: 'warning'
  },
  beta: {
    label: 'Beta',
    className: 'beta',
    intent: 'success'
  },
  new: {
    label: 'New',
    className: 'new',
    intent: 'warning'
  },
  preview: {
    label: 'Preview',
    className: 'preview',
    intent: 'success'
  },
  ea: {
    label: 'EA',
    className: 'ea',
    intent: 'warning'
  }
};
const ProductLabel = ({
  label,
  expiryDate,
  ...rest
}) => {
  if (expiryDate && isPastDate(expiryDate)) {
    return null;
  }
  const match = LABELS[label];
  if (!match) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Tag, _extends({
    className: `product-meta ${match.className}`,
    intent: match.intent
  }, rest), match.label));
};
export default ProductLabel;